export default () => ({
	numberFormats: {
		en: {
			decimal: {
				style: "decimal",
				maximumFractionDigits: 2
			},
			percent: {
				style: "percent",
				maximumFractionDigits: 2
			},
			integer: {
				style: "decimal",
				maximumFractionDigits: 0
			}
		},
		vi: {
			decimal: {
				style: "decimal",
				maximumFractionDigits: 2
			},
			percent: {
				style: "percent",
				maximumFractionDigits: 2
			},
			integer: {
				style: "decimal",
				maximumFractionDigits: 0
			}
		}
	},
	datetimeFormats: {
		en: {
			short: {
				year: "numeric",
				month: "2-digit",
				day: "2-digit"
			},
			long: {
				year: "numeric",
				month: "long",
				day: "numeric"
			},
			time: {
				hour: "numeric",
				minute: "2-digit",
				hour12: true
			},
			datetime: {
				year: "numeric",
				month: "short",
				day: "numeric",
				hour: "numeric",
				minute: "2-digit",
				hour12: false
			}
		},
		vi: {
			short: {
				year: "numeric",
				month: "2-digit",
				day: "2-digit"
			},
			long: {
				year: "numeric",
				month: "long",
				day: "numeric"
			},
			time: {
				hour: "numeric",
				minute: "2-digit",
				hour12: false
			},
			datetime: {
				year: "numeric",
				month: "short",
				day: "numeric",
				hour: "numeric",
				minute: "2-digit",
				hour12: false
			}
		}
	}
});
